// tslint:disable

import * as classNames from "classnames";
import * as React from "react";

import "react-google-maps";

import { ISearchBarProps, SearchBar } from "./search-bar";

import { Classes, IMPDFilterType, MPDList } from "src/mpd-library";

export interface IListProps extends ISearchBarProps {
  hide?: boolean;
  list: any;
  listActive: boolean;
  listItemActive: number;
  onItemClick(event: any, index: number): void;
}

import "./styles.css";

export class List extends React.Component<IListProps> {
  render() {
    const {
      className,
      listActive,
      hide,
      onSearchChange,
      onToggleList,
      onToggleSearchBar,
      searchActive,
      searchValue,
      ...props
    } = this.props;

    const renderDisplayList = (props: any) => {
      return (
        <React.Fragment>
          {props.list.map((element: any, index: number) => (
            <div
              className={classNames(
                "list-item",
                index === props.listItemActive && Classes.ACTIVE
              )}
              key={index}
              onClick={e => props.onItemClick(e, index)}
            >
              <div className="content-container">
                <div className="title">{element.title}</div>
                <div className="subtitle">{element.subtitle}</div>
              </div>
              <img className="list-item-map-container" src={element.src} />
            </div>
          ))}
        </React.Fragment>
      );
    };

    const FilteredList = MPDList(renderDisplayList);

    const classes = classNames(
      "geo-map-list-container",
      listActive && Classes.ACTIVE,
      className
    );

    if (hide) {
      return null;
    }

    const filter: IMPDFilterType = {
      keys: ['title', 'subtitle'],
      value: searchValue
    }

    return (
      <div className={classes}>
        <div className="list-container">
          <SearchBar
            searchActive={searchActive}
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            onToggleList={onToggleList}
            onToggleSearchBar={onToggleSearchBar}
          />
          <div className="list">
            <FilteredList 
              filter={filter}
              {...props}
            />
          </div>
        </div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/maps/geo-map/list/list.tsx